import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import useLocalStorage from 'src/shared/hooks/useLocalStorage';
import {
  Box, Grid, Stack,Avatar,

} from '@mui/material';
import call from 'src/core/services/http';
import { toast } from 'react-toastify';
import Page from "src/shared/components/Page";
import { styled, alpha } from '@mui/material/styles';
import AuthService from 'src/core/access-control/AuthService';
import Iconify from 'src/shared/components/Iconify';
import { useDispatch } from "react-redux";
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { LoadingButton } from '@mui/lab';
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { getOperators } from "../../../shared/reducers/users/SharedUsersAction";



const IndividualFormSchema = Yup.object().shape({
  mobile_number: Yup.string().required("Required"),

});



const IconStyle = styled(Iconify)(({ theme }) => ({
  width: 20,
  height: 20,
  marginTop: 1,
  flexShrink: 0,
  marginRight: theme.spacing(2),
}));

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(30%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});





const ShopProfile = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [inputErr, setInputErr] = useState("");
  const [data, setData] = useState({
    checker_approval_required: false,
    signatory_approval_required: false,
  });
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [{ account_number, created_on, description }] = useLocalStorage('shop-details');
  const merchantId = AuthService.getUserId();
  const [shop] = useLocalStorage('shop-details');


  const defaultValues = {
    "mobile_number": "mobile_number",
    "savings_account_id": "shop.id",

  };


  const methods = useForm({
    resolver: yupResolver(IndividualFormSchema),
    defaultValues,
    mode: 'onChange'
  });

  const {
    handleSubmit, getValues, setValue, reset,
    formState: { isSubmitting },
  } = methods;


  const [state, setState] = useState(defaultValues)
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setisLoading] = useState(false)


  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };


  const getSettings = async () => {
    try {
      const response = await call('get', `/merchants/${merchantId}/savings-accounts/${shop.id}/account-settings/`);
      if (response.data.status) {
        setData(response.data.account_settings);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSettings();
  }, []);


  const accountNumber = shop.account_number

  // formData.append('file', selectedFile);

  const imageUpload = async () => {
    try {
      const formData = new FormData();
      formData.append('logo', selectedImage);
      formData.append('account_number', accountNumber);
      setisLoading(true)
      const res = await call("post", `/jazilia/shop-logo/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });


      if (res.data.status) {
        toast.success(res.data.message);

      } else {
        toast.error(res.data.errors);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred while uploading the image.");
    }
    setisLoading(false)
  };

  const { users } = useSelector(state => state.sharedUser)

  const getUsers = () => {
    let payload = {
      merchantId: AuthService.getUserId(),
      savingsId: shop.id
    }

    dispatch(getOperators(payload))
  }


  useEffect(() => {
    getUsers()
  }, [dispatch])


  return (
    <Page title='Shop Settings'>
      <Grid container>
        <Grid item xs={12} md={4} lg={4}>
          <Card sx={{
            bgcolor: alpha('#1CCAFF', 0.08),
            // border: `solid 2px ${'#1CCAFF'}`,
            boxShadow: `inset 0 4px 8px 0 ${alpha('#1CCAFF', 0.24)}`,
          }} >
            <Stack spacing={2} sx={{ p: 3, textAlign: 'center', height: 400 }}>
              <Avatar
                displayName={profile.subscriber_details?.display_name}
                src={selectedImage}
                sx={{
                  mb: 2,
                  mx: 'auto',
                  borderWidth: 2,
                  borderStyle: 'solid',
                  borderColor: 'common.white',
                  width: { xs: 80, md: 80 },
                  height: { xs: 80, md: 80 },
                }}
              />

<Stack direction="row" alignItems="center" gap={1}>
                <IconStyle icon={'eva:person'} />
                <Button
                  component="label"
                  variant="outlined"
                  startIcon={<CloudUploadIcon />}
                >
                  Upload Profile
                  <VisuallyHiddenInput type="file" onChange={handleImageChange} />
                </Button>
                {selectedImage && (
                  <p sx={{ mb: 10 }}>Selected File: {selectedImage.name}</p>
                )}
                {selectedImage && (
                  <LoadingButton loading={isLoading} variant="outlined" onClick={imageUpload}>
                    <CloudUploadIcon />
                  </LoadingButton>
                )}
              </Stack>
              <Box
                sx={{
                  ml: { md: 3 },
                  mt: { xs: 1, md: 0 },
                  color: 'common.black',
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                <Typography variant="h4">{profile.subscriber_details?.display_name}</Typography>
                <Typography variant="body2" sx={{ color: 'text.primary', opacity: 0.72 }}>
                  Name &nbsp;
                  <Typography sx={{ opacity: 0.72 }}><strong> {description}</strong> </Typography>
                </Typography>
              </Box>
         
              <Stack direction="row">
                <IconStyle icon={'ci:user-01'} />
                <Typography variant="body2">
                  Shop Name &nbsp;
                  <strong>{description}</strong>
                </Typography>
              </Stack>
              <Stack direction="row">
                <IconStyle icon={'eva:phone-fill'} />
                <Typography variant="body2" color="text.primary">
                  Account Number &nbsp;
                  <strong>{account_number}</strong>
                </Typography>
              </Stack>
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </Page>
  )
}

export default ShopProfile;
